var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLabelSolid = function SvgLabelSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "m19.27 9.653-3.567-5.346a1.25 1.25 0 0 0-1.037-.557H3.125A1.25 1.25 0 0 0 1.875 5v10a1.25 1.25 0 0 0 1.25 1.25h11.54a1.25 1.25 0 0 0 1.038-.556l3.565-5.347a.63.63 0 0 0 .002-.694"
  })));
};
export default SvgLabelSolid;